<script setup>
import Down from 'assets/icons/down.svg'

const props = defineProps({
    formSelectConfig: {
        type: Object,
        required: false,
        default: () => ({}),
    },
    modelValue: {
        type: [String, Number],
        default: ''
    }
})

// Define emits
const emit = defineEmits(['update:modelValue'])

// Create a local reactive state for the selected value
const selected = ref(props.modelValue)

// Watch for changes in the modelValue prop and update the selected state
watch(() => props.modelValue, (newValue) => {
    selected.value = newValue
})

// Emit the change event when the selected value changes
const emitChange = () => {
    emit('update:modelValue', selected.value)
}
</script>

<template>
    <div class="form-select-container">
        <label class="form-select-label" :for="formSelectConfig.id">
            {{ formSelectConfig.label }}:
            <span v-if="formSelectConfig.required" class="asterisk-icon">*</span>
            <span v-else class="optional">(optional)</span>
        </label>

        <div class="form-select">
            <select
                :id="formSelectConfig.id"
                v-model="selected"
                :disabled="formSelectConfig.disabled"
                :name="formSelectConfig.name"
                @change="emitChange"
            >
                <option
                    v-for="option in formSelectConfig.options"
                    :key="option.value"
                    :value="option.value"
                    :disabled="option.disabled || formSelectConfig.disabled"
                >
                    {{ option.label }}
                </option>
            </select>

            <Down />
        </div>
    </div>
</template>

<style lang="scss">
.form-select-label {
    @include form-label;
}

.form-select {
    position: relative;

    select {
        @include inputfield;
    }

    svg {
        fill: white;
        position: absolute;
        transform: translateY(-50%);
        top: 50%;
        right: 20px;
        width: 20px;
        pointer-events: none;
    }
}
</style>
